function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.9375 1.5H12V0.75C12 0.336 11.6648 0 11.25 0C10.8353 0 10.5 0.336 10.5 0.75V1.5H4.5V0.75C4.5 0.336 4.16475 0 3.75 0C3.33525 0 3 0.336 3 0.75V1.5H2.0625C0.92475 1.5 0 2.42475 0 3.5625V12C0 13.2405 1.0095 14.25 2.25 14.25H6C6.41475 14.25 6.75 13.914 6.75 13.5C6.75 13.086 6.41475 12.75 6 12.75H2.25C1.836 12.75 1.5 12.4132 1.5 12V6H13.5C13.5 6.414 13.8353 6.75 14.25 6.75C14.6648 6.75 15 6.414 15 6V3.5625C15 2.42475 14.0753 1.5 12.9375 1.5Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.125 8.25C10.437 8.25 8.25 10.437 8.25 13.125C8.25 15.813 10.437 18 13.125 18C15.813 18 18 15.813 18 13.125C18 10.437 15.813 8.25 13.125 8.25ZM15.3795 12.3038L12.942 15.1163C12.8055 15.2738 12.6097 15.3668 12.402 15.375C12.393 15.375 12.384 15.375 12.375 15.375C12.1762 15.375 11.9857 15.2963 11.8447 15.1553L10.5322 13.8428C10.239 13.5495 10.239 13.0755 10.5322 12.7823C10.8255 12.489 11.2995 12.489 11.5927 12.7823L12.336 13.5255L14.2455 11.322C14.517 11.0085 14.991 10.9763 15.3037 11.2463C15.6165 11.517 15.6502 11.991 15.3795 12.3038Z",
  fill: "currentColor"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18,
  fill: "white"
})));

var SvgCalendarIcon = function SvgCalendarIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendarIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar-icon.08df7518.svg";
export { ForwardRef as ReactComponent };